import { CartItemFragment } from 'types/api/tickets.types';

enum Keys {
  Cart = 'cart',
  Tickets = 'tickets',
}

const MutationKeys = {
  tickets: {
    cartUpdate: (id?: CartItemFragment['id']) => [Keys.Tickets, Keys.Cart, id],
  },
} as const;

export default MutationKeys;
